exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{line-height:1.666;color:#666;font-size:14px}body,input{font-family:verdana}body,dd,dl,dt,h1,h2,h3,h4,h5,h6,li,ol,p,table,td,th,ul{margin:0;padding:0}img,table,td,th{border:0}em,i,th{font-style:normal;text-decoration:none}h1,h2,h3,h4,h5,h6,strong,th{font-size:100%;font-weight:400}button,input,select,table,textarea{margin:0;font-family:inherit;font-size:100%}button,input{outline:none}ol,ul{list-style:none}table{border-collapse:collapse;border-spacing:0}caption,th{text-align:left}a{color:#666;text-decoration:none;outline:none;-webkit-tap-highlight-color:transparent}select{background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./src/plugin/elTreeTransfer/src/clear.css
// module id = 17
// module chunks = 0